import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { navigationItems } from "@/data/navigation";

export function Footer({ siteData }) {
  return (
    <footer className="px-4 pb-10 md:px-6" data-testid="site-footer">
      <div className="mx-auto max-w-7xl rounded-[2.5rem] bg-slate-950 px-6 py-10 text-white md:px-10">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr_1fr]">
          <div className="space-y-4">
            <div className="inline-flex rounded-[1.5rem] bg-white px-4 py-3 shadow-[0_18px_40px_rgba(0,0,0,0.18)]" data-testid="footer-logo-frame">
              <img
                alt="Monarch Solar & Roofing Solutions footer logo"
                className="h-24 w-auto object-contain md:h-28"
                data-testid="footer-logo-image"
                src="/monarch-logo-transparent.png"
              />
            </div>
            <p className="text-sm font-semibold uppercase tracking-[0.28em] text-emerald-300" data-testid="footer-brand-tag">
              Monarch Solar & Roofing Solutions
            </p>
            <h2 className="text-3xl font-bold" data-testid="footer-title">
              Built to lower costs, strengthen roofs, and earn trust.
            </h2>
            <p className="max-w-xl text-sm text-white/70" data-testid="footer-description">
              Serving Los Angeles property owners with solar planning, roofing support, and practical lead-first service.
            </p>
          </div>

          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.28em] text-white/50" data-testid="footer-navigation-label">
              Navigation
            </p>
            <div className="mt-4 flex flex-col gap-3">
              {navigationItems.map((item) => (
                <Link className="text-sm text-white/80 transition-colors hover:text-white" data-testid={`footer-nav-${item.label.toLowerCase()}-link`} key={item.path} to={item.path}>
                  {item.label}
                </Link>
              ))}
            </div>
            <p className="mt-6 text-sm font-semibold uppercase tracking-[0.28em] text-white/50" data-testid="footer-seo-links-label">
              Solar pages
            </p>
            <div className="mt-4 flex flex-col gap-3">
              <Link className="text-sm text-white/80 transition-colors hover:text-white" data-testid="footer-seo-installation-link" to="/solar-installation-california">
                Solar Installation California
              </Link>
              <Link className="text-sm text-white/80 transition-colors hover:text-white" data-testid="footer-seo-repair-link" to="/solar-repair-california">
                Solar Repair California
              </Link>
              <Link className="text-sm text-white/80 transition-colors hover:text-white" data-testid="footer-seo-storage-link" to="/battery-storage-california">
                Battery Storage California
              </Link>
              <Link className="text-sm text-white/80 transition-colors hover:text-white" data-testid="footer-seo-areas-link" to="/california-service-areas">
                California Service Areas
              </Link>
            </div>
          </div>

          <div className="space-y-4 rounded-[2rem] border border-white/10 bg-white/5 p-6">
            <p className="text-sm font-semibold uppercase tracking-[0.28em] text-white/50" data-testid="footer-contact-label">
              Contact
            </p>
            <a className="flex items-start gap-3 text-sm text-white/80" data-testid="footer-phone-link" href={`tel:${siteData.phone}`}>
              <Phone className="mt-0.5 h-4 w-4 text-emerald-300" />
              <span>{siteData.phone}</span>
            </a>
            <a className="flex items-start gap-3 text-sm text-white/80" data-testid="footer-email-link" href={`mailto:${siteData.email}`}>
              <Mail className="mt-0.5 h-4 w-4 text-emerald-300" />
              <span>{siteData.email}</span>
            </a>
            <div className="flex items-start gap-3 text-sm text-white/80" data-testid="footer-address-text">
              <MapPin className="mt-0.5 h-4 w-4 text-emerald-300" />
              <span>{siteData.address}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}